/**
 * Mainbeauty — popup chi tiết khóa học ở /khoa-hoc ([data-pi-cmodal]).
 *
 * 🚨 Nội dung được MƯỢN, không nhân bản: khối .pi-cmodal-src nằm sẵn (ẩn) trong thẻ khóa được
 * chuyển vào popup lúc mở và trả về đúng chỗ lúc đóng. Copy innerHTML thì mọi id/anchor trong
 * nội dung soạn thảo tồn tại hai bản cùng lúc — trang vẫn trông bình thường, chỉ có link neo
 * nhảy sai chỗ, nên hỏng kiểu đó rất khó thấy.
 */
import { bindPopupClose } from "./mainbt-popup-form.js";

function initCourseModal() {
  const modal = document.querySelector("[data-pi-cmodal-root]");
  if (!modal) return;

  const title = modal.querySelector("[data-pi-cmodal-title]");
  const body = modal.querySelector("[data-pi-cmodal-body]");

  let source = null; // khối đang mượn
  let home = null; // chỗ phải trả nó về
  let opener = null; // nút đã mở popup — đóng xong focus quay lại đó

  const close = () => {
    if (!modal.classList.contains("is-open")) return;

    modal.classList.remove("is-open");
    document.body.classList.remove("pi-noscroll");

    if (source && home) {
      source.hidden = true;
      home.appendChild(source);
    }
    source = null;
    home = null;

    if (opener) {
      opener.focus();
      opener = null;
    }
  };

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-pi-cmodal]");
    if (!trigger) return;
    e.preventDefault();

    const src = document.getElementById(trigger.getAttribute("data-pi-cmodal"));
    if (!src) return;

    source = src;
    home = src.parentNode;
    src.hidden = false;
    body.appendChild(src);

    title.textContent = trigger.getAttribute("data-pi-cmodal-title") || "";

    modal.classList.add("is-open");
    document.body.classList.add("pi-noscroll");
    opener = trigger;
    // Mở khóa thứ hai sau khi đã cuộn hết khóa thứ nhất: khung phải bắt đầu từ đầu nội dung.
    body.scrollTop = 0;
  });

  bindPopupClose(modal, "[data-pi-cmodal-box]", "[data-pi-cmodal-close]", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
}

/**
 * CTA trang chủ trỏ tới #khoa-<mã> ở /khoa-hoc, mà trang đó chỉ vẽ MỘT khóa — thẻ được trỏ tới
 * có thể đang mang [hidden], và trình duyệt thì không cuộn tới thứ nó không nhìn thấy.
 *
 * Đổi khóa là điều hướng thật (link `?khoa=` trên menu), server chọn sẵn thẻ đúng — nên đây là
 * chỗ duy nhất còn cần JS.
 */
function initTierHash() {
  const tiers = Array.prototype.slice.call(document.querySelectorAll("[data-pi-tier]"));
  if (!tiers.length) return;

  const openHash = () => {
    const id = (window.location.hash || "").replace(/^#/, "");
    if (!id) return;

    const el = document.getElementById(id);
    const card = el && el.closest("[data-pi-tier]");
    if (!card || !card.hidden) return;

    tiers.forEach((other) => {
      other.hidden = other !== card;
    });
    // .tier nằm trong REVEAL_SELECTOR nên nó vào trang với opacity 0 chờ IntersectionObserver;
    // thẻ vừa rời display:none thì lượt quan sát đó không có gì bảo đảm — hiện thẳng.
    card.classList.add("is-visible");
    card.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  window.addEventListener("hashchange", openHash);
  openHash();
}

document.addEventListener("DOMContentLoaded", () => {
  initCourseModal();
  initTierHash();
});
